import React, { FC, HTMLAttributes } from 'react'

import classNames from 'classnames'

import styles from './styles.module.scss'

export type BannerType = 'promo' | 'urgency' | 'velocity'

export interface BannerProps extends HTMLAttributes<HTMLAnchorElement> {
    type: BannerType
}

const Banner: FC<BannerProps> = ({ children, type }) => {
    const promoBannerClassName = classNames(styles.banner, styles[type])

    return (
        <div className={promoBannerClassName} data-testid={`${type}-banner`}>
            {children}
        </div>
    )
}

export default Banner
